import AsyncStorage from '@react-native-async-storage/async-storage';

export const LEGACY_PROFILE_IMAGE_STORAGE_KEY = 'user_profile_image';

const getCurrentUserCacheSuffix = async (): Promise<string | null> => {
  const storedUserId = await AsyncStorage.getItem('@user_id');
  if (storedUserId) {
    return storedUserId;
  }

  const storedUser = await AsyncStorage.getItem('user');
  if (storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      if (parsedUser?.id) {
        return String(parsedUser.id);
      }
      if (parsedUser?.email) {
        return String(parsedUser.email).toLowerCase();
      }
    } catch {
      // Ignore malformed legacy storage and fall through to email.
    }
  }

  const storedEmail = await AsyncStorage.getItem('@user_email');
  return storedEmail ? storedEmail.toLowerCase() : null;
};

export const getProfileImageStorageKey = async (): Promise<string | null> => {
  const cacheSuffix = await getCurrentUserCacheSuffix();
  return cacheSuffix ? `${LEGACY_PROFILE_IMAGE_STORAGE_KEY}:${cacheSuffix}` : null;
};

export const getCachedProfileImage = async (): Promise<string | null> => {
  const storageKey = await getProfileImageStorageKey();
  return storageKey ? AsyncStorage.getItem(storageKey) : null;
};

export const setCachedProfileImage = async (imageData: string): Promise<void> => {
  const storageKey = await getProfileImageStorageKey();
  if (storageKey) {
    await AsyncStorage.setItem(storageKey, imageData);
  }

  await AsyncStorage.removeItem(LEGACY_PROFILE_IMAGE_STORAGE_KEY);
};

export const removeCachedProfileImage = async (): Promise<void> => {
  const storageKey = await getProfileImageStorageKey();
  const keysToRemove = [
    ...(storageKey ? [storageKey] : []),
    LEGACY_PROFILE_IMAGE_STORAGE_KEY,
  ];

  await AsyncStorage.multiRemove(keysToRemove);
};

export const removeAllCachedProfileImages = async (): Promise<void> => {
  if (typeof (AsyncStorage as any).getAllKeys !== 'function') {
    await removeCachedProfileImage();
    return;
  }

  const allKeys = await AsyncStorage.getAllKeys();
  const profileImageKeys = allKeys.filter(
    (key) =>
      key === LEGACY_PROFILE_IMAGE_STORAGE_KEY ||
      key.startsWith(`${LEGACY_PROFILE_IMAGE_STORAGE_KEY}:`),
  );

  if (profileImageKeys.length > 0) {
    await AsyncStorage.multiRemove(profileImageKeys);
  }
};
